import React from 'react';
import './genericeditmenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Animation as AnimationIcon } from '@mui/icons-material';
import { AssetType } from '../../../types/typing.ts';
interface GenericEditMenuProps {
  selectedAssetOnCanvas: {
    id: string;
    selectedAsset: AssetType;
  };
  onMenuClick: (menu: string) => void;
  onDeleteAsset: ({
    id,
    assetType,
  }: {
    id: string;
    assetType: AssetType;
  }) => void;
}

const GenericEditMenu: React.FC<GenericEditMenuProps> = ({
  selectedAssetOnCanvas,
  onMenuClick,
  onDeleteAsset,
}) => {
  return (
    <div className="text-edit-menu">
      <div className="menu-group">
        <button
          className="text-style-button icon-menu-button"
          onClick={() => onMenuClick('layer')}
          title="Layering menu"
        >
          <FontAwesomeIcon icon={faLayerGroup} />
        </button>
        <button
          className="text-style-button-animate icon-menu-button"
          onClick={() => onMenuClick('animations')}
          title="Animation menu"
        >
          <AnimationIcon />
        </button>
        <button
          className="delete-button icon-menu-button"
          onClick={() =>
            onDeleteAsset({
              id: selectedAssetOnCanvas.id,
              assetType: selectedAssetOnCanvas.selectedAsset,
            })
          }
          title="Delete selected item"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default GenericEditMenu;
